/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      this.wrapButtonLetters();
    },

    finalize: function() {
    },

    wrapButtonLetters: function() {
      const processButton = ( button ) => {
        const dataContent = button.querySelector( 'span[data-content]' );
        if ( !dataContent ) return;

        const text = dataContent.textContent.trim();
        dataContent.innerHTML = '';

        for ( let i = 0; i < text.length; i++ ) {
          const span = document.createElement( 'span' );
          span.className = 'char';
          span.setAttribute( 'data-letter', text[i] );
          if ( text[i] === ' ' ) {
            span.innerHTML = '&nbsp;';
          } else {
            span.textContent = text[i];
          }

          span.style.setProperty( '--char', `"${text[i]}"` );
          span.style.setProperty( '--char-index', i );

          dataContent.appendChild( span );
        }
      };

      const primaryButtons = document.querySelectorAll( '.btn-primary' );
      const secondaryButtons = document.querySelectorAll( '.btn-secondary' );

      primaryButtons.forEach( processButton );
      secondaryButtons.forEach( processButton );
    },
  };

  app.registerComponent( 'bag', COMPONENT );
} )( app );
